<section class="inline-flex w-full">
  <div class="hidden md:block step-navigation-bar sm:col-3 md:col-2 px-0">
    @for (step of steps; track step; let i = $index; let last = $last) {
      <button
        class="step"
        [class.active]="selectedIndex === i"
        (click)="selectStepByIndex(i)"
        [disabled]="!step.completed && i !== getCurrentStepIndex()">
        <div class="flex mb-2">
          @if (i === selectedIndex) {
            <div>
              <img src="assets/icons/step-symbol-current.svg" class="step-trail" alt="" />
            </div>
          }
          @if (i === selectedIndex) {
            <div class="span align-content-center text-left progress-text-color" style="padding-left: 10px">
              <span>{{ step.label }}</span>
            </div>
          }

          @if (i !== selectedIndex) {
            <div
              class="circle"
              [class.progress-border-color]="step.completed"
              [class.progress-text-color]="step.completed"
              [class.initial-border-color]="!step.completed"
              [class.initial-text-color]="!step.completed">
              <span> 0{{ i + 1 }} </span>
            </div>
          }
          @if (i !== selectedIndex) {
            <div
              class="span align-content-center text-left"
              [class.progress-text-color]="step.completed"
              [class.initial-step-label]="!step.completed">
              <span>{{ step.label }}</span>
            </div>
          }
        </div>

        @if (!last) {
          <div class="">
            @if (step.completed) {
              <img src="assets/icons/Step-Trail-active.svg" class="step-trail" alt="step trail" />
            }
            @if (!step.completed) {
              <img src="assets/icons/Step-Trail.svg" class="step-trail" alt="step active" />
            }
          </div>
        }
      </button>
    }
  </div>
  <div class="step-content sm:col-9 md:col-10">
    <div class="block md:hidden sm:col-12 mobile-step-label small-step">
      <span>Step {{ selectedIndex + 1 }}/{{ steps.length }}-{{ steps.get(selectedIndex)?.label }}</span>
    </div>

    <div [ngTemplateOutlet]="selected ? selected.content : null"></div>
    <div class="grid">
      <div class="col-12 md:ml-5">
        <div class="flex justify-content-between align-items-center">
          @if (selectedIndex === checkoutStep.OrderInfo) {
            <p-button styleClass="p-0 w-0 h-0 bg-transparent border-0" />
          }
          @if (!(selectedIndex === checkoutStep.OrderInfo)) {
            <p-button
              label="{{ 'Checkout.Previous' | translate }}"
              styleClass="p-button-outlined p-button-rounded"
              class="p-2"
              (onClick)="previousStep()"
              [loading]="_previousLoading()" />
          }
          <p-button
            label="{{
              selectedIndex === checkoutStep.ConfirmOrder
                ? ('Checkout.SubmitOrder' | translate)
                : ('Checkout.Next' | translate)
            }}"
            styleClass="p-button-rounded"
            class="p-2"
            [disabled]="_nextStepDisabled()"
            (onClick)="nextStep()"
            [loading]="_nextLoading()" />
        </div>
      </div>
      <div class="col-12 mt-3 md:ml-5">
        <div class="flex justify-content-between">
          <p-button
            label="{{ 'Checkout.Cancel' | translate }}"
            (onClick)="cancelOrder()"
            styleClass="p-button-link-black p-button-sm p-2"
            [loading]="_cancelLoading()" />
          @if (!(selectedIndex === checkoutStep.ConfirmOrder)) {
            <p-button
              label="{{ 'Checkout.Save_Draft_Exit' | translate }}"
              (onClick)="draftOrSubmitOrder()"
              styleClass="p-button-link-black p-button-sm p-2"
              [loading]="_draftOrSubmitLoading()" />
          }
        </div>
      </div>
    </div>
  </div>
</section>
